import { TextField, OutlinedTextFieldProps, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'

export interface ILoginInputProps extends Partial<OutlinedTextFieldProps> {
  errorMessage?: string
}

const LoginInput = ({ errorMessage, ...props }: ILoginInputProps) => {
  return (
    <Stack>
      <TextField
        {...props}
        fullWidth
        variant="outlined"
        sx={{
          background: 'transparent',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: props.error ? 'red.500' : '#F0F0F0',
              borderWidth: props.error ? '2px' : '1px'
            },
            '&:hover fieldset': {
              borderColor: props.error ? 'red.500' : '#F0F0F0',
              borderWidth: props.error ? '2px' : '1px'
            },
            '&.Mui-focused fieldset': {
              borderColor: props.error ? 'red.500' : '#F0F0F0',
              borderWidth: '2px'
            }
          }
        }}
        InputProps={{
          ...props.InputProps,
          sx: {
            background: 'white',
            height: '64px',
            border: 'solid 1px #F0F0F0',
            borderRadius: '16px',
            px: '25px',

            input: {
              pl: '10px',
              '&::placeholder': {
                fontSize: '14px',
                lineHeight: '20px',
                color: 'content.tertiary',
                textTransform: 'capitalize',
                fontWeight: 400,
                fontStyle: 'italic',
                opacity: 1
              }
            }
          }
        }}
      />
      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography
          sx={{
            visibility: errorMessage ? 'visible' : 'hidden',
            color: 'red.600',
            fontSize: '12px',
            lineHeight: '24px',
            fontWeight: 400,
            minHeight: '24px'
          }}>
          {errorMessage}
        </Typography>
      </Box>
    </Stack>
  )
}

export default LoginInput
